import { createStyles } from "@mantine/emotion";

export default createStyles ( ( {
	donationTabEmptyViewContainer: {
		display        : "flex",
		justifyContent : "center",
		alignItems     : "center",
		height         : "80%"
	},
	content: {
		textAlign: "center"
	},
	svgIcon: {
		height       : "12rem",
		width        : "12rem",
		marginBottom : "1rem"
	}
} )
);

